import { ColumnDef } from '@tanstack/react-table';
import { Segment } from '../types';
import { Button } from '@/components/ui/button';
import { MoreVertical } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { formatRelativeDate } from '@/lib/format-date';
import { getTotalSubscribers, getSegmentSize } from '../utils';

export const columns: ColumnDef<Segment>[] = [
  {
    id: 'size',
    accessorFn: (row) => {
      const total = getTotalSubscribers(row.channelCounts);
      return getSegmentSize(total);
    },
    enableHiding: false,
    meta: {
      isFilterOnly: true
    }
  },
  {
    accessorKey: 'name',
    header: 'Segment',
    cell: ({ row }) => <div className="font-medium">{row.getValue('name')}</div>,
    enableSorting: true
  },
  {
    accessorKey: 'description',
    header: 'Description',
    enableSorting: true
  },
  {
    accessorKey: 'channelCounts.sms',
    header: 'SMS',
    cell: ({ row }) => {
      const count = row.original.channelCounts.sms;
      return <div className="font-medium tabular-nums">{count.toLocaleString()}</div>;
    },
    size: 100,
    enableSorting: true
  },
  {
    accessorKey: 'lastSync',
    header: 'Last Sync',
    cell: ({ row }) => {
      return (
        <div className="text-muted-foreground">{formatRelativeDate(row.getValue('lastSync'))}</div>
      );
    },
    size: 120,
    enableSorting: true
  },
  {
    accessorKey: 'createdAt',
    header: 'Created',
    cell: ({ row }) => {
      return (
        <div className="text-muted-foreground">{formatRelativeDate(row.getValue('createdAt'))}</div>
      );
    },
    size: 120,
    enableSorting: true
  },
  {
    id: 'actions',
    cell: ({ row }) => {
      const segment = row.original;

      return (
        <DropdownMenu>
          <DropdownMenuTrigger
            asChild
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Button variant="ghost" className="h-8 w-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreVertical className="h-4 w-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                // TODO: Implement refresh
                console.log('Refresh segment:', segment.id);
              }}
            >
              Refresh Segment
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                // TODO: Implement duplicate
                console.log('Duplicate segment:', segment.id);
              }}
            >
              Duplicate Segment
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={(e) => {
                e.stopPropagation();
                // TODO: Implement edit
                console.log('Edit segment:', segment.id);
              }}
            >
              Edit Segment
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      );
    },
    size: 50
  }
];
